/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import {
    object, string, arrayOf, shape, number,
} from 'prop-types';
import {
    Grid, Typography, withStyles,
} from '@material-ui/core';
import OtherRecommendationV2 from './OtherRecommendation';
import GiftListProductDetails from './GiftListProductDetails';
import ShopTheSite from '../DesktopGiftList/RecipientDetails/ShopTheSite';

const styles = (theme) => ({
    headerTitle: {
        lineHeight: '1.25rem',
        fontWeight: 700,
        fontSize: '1rem',
        padding: '22px 0px',
        letterSpacing: ' 0.32px',
        minWidth: '133px',
        '@media only screen and (max-width: 600.5px) ': {
            padding: '12px 0px',
            fontSize: '14px',
        },
        '@media only screen and (max-width: 410px) ': {
            padding: '12px 0px 0px',
            fontSize: '16px',
        },
    },

    innerContainer: {
        backgroundColor: 'rgba(246, 244, 238, 1)',
        padding: '16px 22px',
        '@media only screen and (max-width: 768.5px) ': {
            padding: '18px 16px',
        },
    },
    enterItemContainer: {
        display: 'flex',
        gap: '16px',
        '@media only screen and (max-width: 600px) ': {
            gridTemplateColumns: 'repeat(1, 1fr)',
        },
        '& .findAnotherGift , .tooltipWrapper': {
            display: 'none',
        },
    },
    enterItem: {
        borderTop: `1px solid ${(theme.palette.text?.giftListBorder || '#D5D5D5')}`,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        '@media only screen and (max-width: 410px)': {
            flexDirection: 'column',
        },
        '& .cardFooter': {
            display: 'flex',
            padding: 24,
            borderTop: 'none',
            '@media only screen and (max-width: 600px) ': {
                padding: '12px 0px 12px 15px',
            },
            '@media only screen and (max-width: 410px) ': {
                padding: '12px 0px 0px 15px',
            },
            '& .shopTheSiteWrapper': {
                display: 'flex',
                alignItems: 'center',
                '& .enter-item-number': {
                    display: 'flex',
                    alignItems: 'center',
                },
                '& .shop-the-site-button, & .enter-item-number-button': {
                    textDecoration: 'underline',
                    marginRight: 24,
                    fontWeight: 400,
                    cursor: 'pointer',
                    fontSize: '16px',
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'nowrap',
                    flexDirection: 'row',
                    '& svg': {
                        width: '16px',
                        margin: '0px 20px 0px 8px',
                    },
                    '@media only screen and (max-width: 600px) ': {
                        marginRight: '0px',
                        fontSize: '14px',
                    },
                },
            },
        },
    },
});

const RecipientBoxExpand = ({
    classes, recipient,
}) => {
    const recipientNoError = recipient;
    recipientNoError.error = {};
    const [open, setOpen] = useState(false);
    const [data, setData] = useState({});
    return (
        <div className={classes.container}>
            <Grid container>
                <Grid item xs={12} className={classes.collapseContainer}>
                    <OtherRecommendationV2
                        recipient={recipient}
                        setOpen={setOpen}
                        setData={setData}
                    />
                </Grid>
                <Grid className={classes.enterItem}>
                    <Typography className={classes.headerTitle}>
                        More Ways To Shop:
                    </Typography>
                    {/* Enter item number & Shop the site */}
                    <div className={classes.enterItemContainer}>
                        <ShopTheSite
                            customClass="cardFooter"
                            recipient={recipient}
                            GiftListV2
                        />
                    </div>
                </Grid>

            </Grid>
            {open && <GiftListProductDetails product={data} open={open} setOpen={setOpen} recipient={recipient} setData={setData} />}
        </div>
    );
};

RecipientBoxExpand.propTypes = {
    classes: object.isRequired,
    recipient: shape({
        AddressBookEntryId: string,
        FirstName: string,
        LastName: string,
        EmailAddress: string,
        LastUpdateDate: string,
        PhoneNumber: string,
        Addresses: arrayOf(
            shape({
                AddressId: number,
                AddressBookEntryId: string,
                AddressType: string,
                AddressLineOne: string,
                AddressLineTwo: string,
                City: string,
                PostalCode: string,
                Country: string,
            }),
        ),
    }),
};
RecipientBoxExpand.defaultProps = {
    recipient: {},
};
export default withStyles(styles)(RecipientBoxExpand);
